<nb-card>
  <nb-card-header>
    <h6 class="text-heading">Chọn phương thức bán hàng</h6>
  </nb-card-header>
  <nb-card-body>
    <button
      *ngIf="shopService.shop.receipt"
      nbButton
      hero
      shape="semi-round"
      status="primary"
      size="small"
      (click)="onRetail()"
    >
      <nb-icon icon="file-add-outline"></nb-icon>
      Bán lẻ
    </button>

    <button
      *ngIf="shopService.shop.trade"
      nbButton
      hero
      shape="semi-round"
      status="success"
      size="small"
      (click)="onTrade()"
    >
      <nb-icon icon="file-add-outline"></nb-icon>
      Bán sỉ
    </button>

    <button
      *ngIf="shopService.shop.receiptPurchase"
      nbButton
      outline
      shape="semi-round"
      status="info"
      size="small"
      (click)="onReceiptPurchase()"
    >
      <nb-icon icon="shopping-cart-outline"></nb-icon>
      Mua bán
    </button>
  </nb-card-body>
</nb-card>
